import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {SearchCustomerDto, CustomerContactDto, CustomerService} from '../../../_services/configuration-services';
import {EMPTY, merge, Observable, of, Subject} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, switchMap, tap} from 'rxjs/operators';
import {NgbTypeaheadSelectItemEvent} from '@ng-bootstrap/ng-bootstrap';
import {faEraser} from '@fortawesome/free-solid-svg-icons';
import {FormUtils} from '../../form-utils';

@Component({
    selector: 'app-search-customer',
    templateUrl: './search-customer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchCustomerComponent implements OnInit {

    @Input() customerContact: CustomerContactDto | null;
    @Input() disabled = false;

    @Output() selectedCustomerEvent = new EventEmitter<SearchCustomerDto>();

    searchSubject$ = new Subject<string>();

    searchText: string | null = null;
    selectedCustomer: SearchCustomerDto | null = null;
    printedSelectedCustomer: string | null = null;

    textInputPattern = FormUtils.textInputPattern;

    searchFailed = false;

    icons = {
        erase: faEraser
    };

    formatter = (customer: SearchCustomerDto | null) => customer ? `${customer.customerNumber} ${customer.lastName} ${customer.firstName}` : '';

    search = (text$: Observable<string>) => {
        const debouncedText$ = text$.pipe(
            debounceTime(200),
            distinctUntilChanged());

        return merge(debouncedText$, this.searchSubject$).pipe(
            switchMap(term => {
                if (term.length < 1) {
                    return of([]);
                }

                if (this.printedSelectedCustomer === term) {
                    return EMPTY;
                }

                return this.customerService.searchCustomer(term)
                    .pipe(tap(res => {
                        if (res == null || res.length === 0) {
                            this.searchFailed = true;
                            this.selectCustomer(null);
                            return of([]);
                        }
                        this.searchFailed = false;
                        return of([]);
                    }),
                    catchError(() => {
                        this.searchFailed = true;
                        this.selectCustomer(null);
                        return of([]);
                    }))
                }
            ));
    }

    constructor(private readonly customerService: CustomerService) {
    }

    ngOnInit(): void {
        this.selectCustomer(this.customerContact);
    }

    selectItem(selectItemEvent: NgbTypeaheadSelectItemEvent<SearchCustomerDto>): void {
        this.selectCustomer(selectItemEvent.item);
    }

    public setSelectedCustomer(customerContact: CustomerContactDto | null): void {
        this.selectCustomer(customerContact);
    }

    public clearInput(): Array<SearchCustomerDto> {
        this.searchFailed = false;
        this.selectCustomer(null, true);
        return [];
    }

    private selectCustomer(customer: CustomerContactDto | null, force = false): void {
        if (customer || force) {
            this.selectedCustomer = customer;
            this.customerContact = customer;
            this.printedSelectedCustomer = this.formatter(customer);
            this.selectedCustomerEvent.emit(customer);

        } else {
            this.selectedCustomerEvent.emit(null);
        }
    }

}
